export default __webpack_public_path__ + "static/media/bookListCVEmpty.6d2eab65.png";